<template>
  <div class="col-md-4 ml-auto mr-auto">
    <form @submit.prevent="login">
      <card class="card-login card-plain">
        <div slot="header">
          <div class="logo-container">
            <img :src="logoSrc" alt />
          </div>
        </div>

        <div>
          <div class="text-center login-title">
            <h3>
              <router-link class="link footer-link" to="/register">{{$t("Login.SI.Name")}}</router-link>
            </h3>
          </div>
          <p style="color:#BA0000;" v-if="signinError">
            <strong>{{$t("Login.SI.Sign_In_Error")}}</strong>
          </p>
          <p style="color:#BA0000;" v-show="signLockError">
            <strong>{{ $t("Login.SI.Sign_Lock_Error") }}</strong>
          </p>
          <fg-input
            v-model="model.account"
            v-validate="'required'"
            name="account"
            :error="getError('account')"
            class="no-border form-control-lg"
            placeholder="Account"
            addon-left-icon="now-ui-icons users_circle-08"
          ></fg-input>

          <fg-input
            v-model="model.email"
            v-validate="'required|email'"
            name="username"
            :error="getError('username')"
            class="no-border form-control-lg"
            placeholder="Email"
            addon-left-icon="now-ui-icons ui-1_email-85"
          ></fg-input>

          <fg-input
            v-model="model.password"
            v-validate="'required|min:5'"
            type="password"
            name="password"
            :error="getError('password')"
            class="no-border form-control-lg"
            placeholder="Password"
            addon-left-icon="now-ui-icons ui-1_lock-circle-open"
          ></fg-input>
          <p v-show="signLockError" class="nav-align-center" >
            <strong style="color:#BA0000;">請於{{ formattedTime }}後再試</strong>
          </p>
        </div>

        <div slot="footer">
          <div class="d-block text-center mb-2">{{$t("Login.SI.Version",{ version: `：v${version}`})}}</div>
          <n-button native-type="submit" type="success" round block size="lg">{{$t("Login.SI.Login")}}</n-button>
          <br/>
          <!-- <div class="pull-left">
            <h6>
              <router-link class="link footer-link" to="/register">
                Create Account
              </router-link>
            </h6>
          </div>

          <div class="pull-right">
            <h6><a href="#pablo" class="link footer-link">Need Help?</a></h6>
          </div>-->
        </div>
      </card>
    </form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "login",
  data() {
    return {
      signinError: false,
      remainingSeconds: 0,
      countdownId: null,
      signLockError: false,
      model: {
        account: "",
        email: "",
        password: ""
      }
    };
  },
  computed: {
    version() {
      return process.env.PACKAGE_VERSION;
    },
    logoSrc() {
      // "img/qc_logo.png"
      return process.env.VUE_APP_LOGO;
    },
    formattedTime() {
      const minutes = Math.floor(this.remainingSeconds / 60);
      const seconds = this.remainingSeconds % 60;
      return `${minutes} 分 ${seconds} 秒`;
    }
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    // async ssoLogin() {
    //   const params = new URLSearchParams();
    //   params.append('response_type', 'code');
    //   params.append('client_id', 'aa2d3727-7368-547b-874f-bb13551eda89');
    //   params.append('redirect_uri', 'https://app-dev.quickclick.cc/auth/dotdot/callback');
    //   params.append('scope', 'openid');
    //   params.append('type', 'si');
    //   //重定向用户到认证服务器
    //   window.location = `https://app-dev.quickclick.cc/auth/dotdot?${params.toString()}`;
    // },
    async login() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        // TIP use this.model to send it to api and perform login call
        // 因為 action 包裝了 Promise 所以可以使用 then 和 catch 來接收非同步回傳狀態
        this.$store
          .dispatch("login", {
            type: "si",
            account: this.model.account,
            username: this.model.email,
            password: this.model.password
          })
          .then(() => {
            // 接收 resolve
            // console.log('3. get Promise resolve');
            setTimeout(() => {
              // 使用 $router.push 轉跳到 hello Page
              this.$router.push("/");
            }, 1000);
          })
          .catch(e => {
            // 接收 reject
            if (e.data.remaining_seconds) {
              this.signinError = false;
              this.signLockError = true;
              this.remainingSeconds = e.data.remaining_seconds;
              this.startCountdown();
            } else {
              this.signinError = true;
            }
          }
        );
      }
    },
    startCountdown(){
       if(this.countdownId != null){
         clearInterval(this.countdownId);
         this.countdownId = null;
       }
       this.countdownId = setInterval(() => {
        this.remainingSeconds--;
      }, 1000);
    },
  },
  watch: {
    'model.email': function(val){
        if(typeof val == 'string') this.model.email = val.trim();
      },
    remainingSeconds: function(newRemainingSeconds) {
      if (newRemainingSeconds <= 0) {
        clearInterval(this.countdownId);
        this.signLockError = false;
      }      
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
